export class Model_CRM_City
    {
        
  
         
        public ZoneName : string;
        public StateName: string;
        public CountryName  :string;
        public CityName :string;
        public ZoneId:  number;
        public CountryId: number;
        public StateId :number;  
        public CityId:number;
        public IsActive :boolean;

    


        
    }       